/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { NameValue } from '../../tool/name-value';

/**
 * List of parameter on a RestService request
 */
export class HttpFilter {
  private filters: NameValue[];
  public constructor(filters?: NameValue[]) {
    this.filters = filters ? filters : [];
  }

  public hasFilter(): boolean {
    return this.filters.length > 0;
  }

  /**
   * Add filter
   * @param name
   * @param value
   */
  public setFilters(name: string, value: any, unique = true) {
    const item = this.getFilter(name);
    if (item && unique) {
      item.value = value;
    } else {
      this.filters.push(new NameValue(name, value));
    }
  }

  public getFilters(): NameValue[] {
    return this.filters;
  }

  /**
   * Remove a filter by name if exist
   * @param name
   */
  public removeFilters(name: string) {
    const index = this.filters.findIndex((filter) => {
      return filter.name === name;
    });
    if (index >= 0) {
      this.filters.splice(index, 1);
    }
  }

  public concat(filters: HttpFilter) {
    for (const f of filters.filters) {
      this.filters.push(f);
    }
  }
  /**
   * Get filter by name
   * @param name
   */
  public getFilter(name: string) {
    return this.filters.find((filter) => {
      return filter.name === name;
    });
  }

  /**
   * Convert params to url encode parameters
   */
  public toString(): string {
    let str = '';
    for (const filter of this.filters) {
      if (filter.value instanceof Array) {
        for (const v of filter.value) {
          str += `&${filter.name}=${v}`;
        }
      } else {
        str += `&${filter.name}=${filter.value}`;
      }
    }
    return str.replace(/\+/gi, '%2B');
  }
}
